<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartData: {
      type: Object,
      required: false,
      default: null,
    },
  },
  mounted() {
    let chartOptions = {
      scales: {
        yAxes: [
          {
            ticks: {
              fontColor: "#bdd3e9",
              beginAtZero: true,
              callback: function (value) {
                return value + " chaos";
              },
            },
          },
        ],
        xAxes: [{ ticks: { fontColor: "#bdd3e9" } }],
      },
      responsive: true,
      maintainAspectRatio: false,
    };

    this.renderChart(this.chartData, chartOptions);
  },
};
</script>